export interface DocHeading {
  id: string;
  text: string;
  level: 2 | 3;
}

/**
 * TOC из HTML статьи. Без DOMParser — иначе Node SSR падает (нет DOMParser в Node 18).
 */
export function extractDocHeadings(html: string): DocHeading[] {
  if (!html) {
    return [];
  }

  const items: DocHeading[] = [];
  const headingRe = /<h([23])\b([^>]*)>([\s\S]*?)<\/h\1>/gi;
  let match: RegExpExecArray | null;

  while ((match = headingRe.exec(html)) !== null) {
    const level = Number(match[1]) as 2 | 3;
    const id = headingId(match[2] ?? '');
    const text = decodeHeadingText(match[3] ?? '');
    if (!id || !text) {
      continue;
    }
    items.push({id, text, level});
  }

  return items;
}

function headingId(attrs: string): string {
  const attr = /\bid\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i.exec(attrs);
  return (attr?.[1] ?? attr?.[2] ?? attr?.[3] ?? '').trim();
}

function decodeHeadingText(innerHtml: string): string {
  const text = innerHtml
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, ' ')
    .trim();

  return text;
}
